var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckCircleIcon = function SvgCheckCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.56,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.699 5.622a.664.664 0 0 1 0 .9l-5.877 6.226a.577.577 0 0 1-.85 0l-2.671-2.83a.664.664 0 0 1 0-.9.577.577 0 0 1 .85 0l2.246 2.38 5.452-5.776a.577.577 0 0 1 .85 0Z",
    fill: "#111"
  })));
};

export default SvgCheckCircleIcon;